import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { SET_LOADING } from "../redux/action-types";
import CardHeader from "../components/CardHeader/CardHeader";
import Card from "../components/Card/Card";
import { addCustodianType } from "../redux/actions";

import styled from "styled-components";
import theme from "../theme/theme";
import { useHistory } from "react-router-dom";
import LoadingBar from "../components/LoadingBar/LoadingBar";
import Header from "../components/Header";

const BodyWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 3%;

  .formContainer__header {
    margin-left: 3em;
    max-width: 80%;
  }
  .card_types {
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: center;
    justify-content: center;
  }

  button {
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
    @media (max-width: 480px) {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
    & div {
      @media (max-width: 480px) {
        width: 50%;
        padding: 20px;
      }
    }
  }

  .card_size {
    min-width: 50%;
    text-align: center;
    color: ${theme.colors.primaryStrong2X};
    font-weight: bold;
    font-size: 18px;
  }

  @media (max-width: 480px) {
    .card_size {
      width: 100%;
      text-align: center;
    }
  }
`;

const SelectCustodianType = () => {
  const custodianTypes = ["Individual", "Joint", "IRA"];
  const { setGoalToLaunchPayLoad, loading, userAccountDetails } = useSelector(
    (state) => state.user
  );
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    if (userAccountDetails) {
      dispatch({ type: SET_LOADING, payload: false });
    }
  }, [userAccountDetails, dispatch]);

  const [isLoaded, setIsLoaded] = useState(true);

  useEffect(() => {
    if (loading) {
      setIsLoaded(false);
    }
  }, [loading]);

  const submitType = (type) => {
    const sendType = type?.toUpperCase();
    if (type === "Individual") {
      dispatch(addCustodianType(sendType, setGoalToLaunchPayLoad?.goalId));
      history.push("/individual-form");
    } else if (type === "IRA") {
      dispatch(addCustodianType(sendType, setGoalToLaunchPayLoad?.goalId));
      history.push("/ria-form");
    } else if (type === "Joint") {
      dispatch(addCustodianType(sendType, setGoalToLaunchPayLoad?.goalId));
      history.push("/joint-form");
    }
  };

  return (
    <>
      <Header />
      {(!isLoaded || loading) && (
        <LoadingBar isLoading={loading} setIsLoaded={setIsLoaded} />
      )}
      <BodyWrapper>
        <div className="formContainer">
          <div className="formContainer__header">
            <CardHeader
              text={"What type of account will you be opening today?"}
            />
          </div>
          <div className="card_types">
            {custodianTypes?.map((type) => (
              <button
                key={type}
                className="card_size"
                onClick={() => submitType(type)}
              >
                <Card>{type}</Card>
              </button>
            ))}
          </div>
        </div>
      </BodyWrapper>
    </>
  );
};

export default SelectCustodianType;
